// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class PriceListResource extends Resource {
    basePath: string = 'billing/price-list/';

    objectPath: string = 'billing/price-list/{ident}/';
}
